module.exports = __webpack_public_path__ + "static/media/onlyninja.068df70d.png";